/* Uvítací okno se slevou 10 % (2026-09-19).

   KDY SE UKÁŽE: po dvanácti sekundách na stránce, nebo dřív, když kurzor
   vyjede nahoru z okna (na počítači to obvykle znamená „odcházím"). Ne na
   košíku a ne na stránce oblíbených — tam už má návštěvník rozdělanou práci.

   KOLIKRÁT: kdo se přihlásí, neuvidí ho nikdy víc. Kdo ho zavře, má pokoj
   třicet dní. Drží se to v prohlížeči; v anonymním okně se proto ukáže
   znovu — smůla, ale lepší než nic neukládat.

   E-MAIL se posílá obyčejným zákaznickým formulářem Shopify, tedy s načtením
   stránky. Na pozadí to nejde: obchod má zapnutou ochranu formulářů a bez
   jejího neviditelného tokenu vrací Shopify chybu 400 („Missing CAPTCHA
   token"). Po návratu z odeslání je ve značce `[data-uvitani-uspech]`
   a okno se otevře rovnou s kódem. */
(function () {
  'use strict';

  var KLIC = 'galelie-uvitani';
  var PO_ZAVRENI_DNI = 30;
  var PRODLEVA_MS = 12000;

  var okno = document.querySelector('[data-uvitani]');
  if (!okno) return;

  // Košík a pokladna: tam nikoho nevyrušovat.
  var cesta = window.location.pathname;
  if (/\/(cart|checkout)/.test(cesta)) return;

  function stav() {
    try {
      var s = window.localStorage.getItem(KLIC);
      return s ? JSON.parse(s) : null;
    } catch (e) {
      return null;
    }
  }

  function ulozStav(co) {
    try {
      window.localStorage.setItem(KLIC, JSON.stringify({ co: co, kdy: Date.now() }));
    } catch (e) {
      /* Bez úložiště se okno ukáže příště znovu. Nic horšího se nestane. */
    }
  }

  // Návrat z odeslání formuláře. Musí se vyhodnotit DŘÍV než „už to viděl",
  // jinak by se kód nikdy neukázal tomu, kdo se právě přihlásil.
  var uspech = !!okno.querySelector('[data-uvitani-uspech]');
  var selhalo = !!okno.querySelector('[data-uvitani-selhalo]');

  var predtim = stav();
  if (!uspech && !selhalo && predtim) {
    if (predtim.co === 'prihlasen') return;
    var dni = (Date.now() - (predtim.kdy || 0)) / 86400000;
    if (dni < PO_ZAVRENI_DNI) return;
  }

  var otevreno = false;
  var vratitFokus = null;
  var casovac = null;

  function otevri() {
    if (otevreno) return;
    otevreno = true;
    zrus();
    vratitFokus = document.activeElement;
    okno.hidden = false;
    document.documentElement.classList.add('uvitani-zamek');
    var pole = okno.querySelector('.uvitani-pole');
    if (pole) {
      // Na telefonu by okamžité zaostření vytáhlo klávesnici přes celé okno.
      if (window.innerWidth > 820) pole.focus();
    }
    document.addEventListener('keydown', klavesa);
  }

  function zavri(duvod) {
    if (!otevreno) return;
    otevreno = false;
    okno.hidden = true;
    document.documentElement.classList.remove('uvitani-zamek');
    document.removeEventListener('keydown', klavesa);
    ulozStav(duvod || 'zavreno');
    if (vratitFokus && vratitFokus.focus) vratitFokus.focus();
  }

  function klavesa(e) {
    if (e.key === 'Escape') zavri('zavreno');
  }

  function zrus() {
    if (casovac) { window.clearTimeout(casovac); casovac = null; }
    document.removeEventListener('mouseout', odchod);
  }

  function odchod(e) {
    // Kurzor opustil okno horem a nemíří do jiného prvku stránky.
    if (e.clientY > 0 || e.relatedTarget) return;
    otevri();
  }

  Array.prototype.forEach.call(okno.querySelectorAll('[data-uvitani-zavri]'), function (el) {
    el.addEventListener('click', function () { zavri('zavreno'); });
  });

  /* ------------------------------------------------- odeslání e-mailu */

  var formular = okno.querySelector('.uvitani-formular');
  var hotovo = okno.querySelector('[data-uvitani-hotovo]');
  var chyba = okno.querySelector('[data-uvitani-chyba]');
  var kodEl = okno.querySelector('[data-uvitani-kod]');

  // Formulář se odesílá normálně; tady se jen ukáže, jak to dopadlo.
  function ukazVysledek() {
    if (uspech) {
      if (formular) formular.hidden = true;
      if (kodEl) kodEl.textContent = okno.getAttribute('data-kod') || '';
      if (hotovo) hotovo.hidden = false;
      ulozStav('prihlasen');
    } else if (selhalo && chyba) {
      chyba.hidden = false;
    }
  }

  /* ------------------------------------------------- spuštění */

  function naplanuj() {
    // Po odeslání se okno otevře hned — návštěvník čeká na kód, ne na to,
    // až uplyne dvanáct sekund.
    if (uspech || selhalo) {
      ukazVysledek();
      otevri();
      return;
    }
    casovac = window.setTimeout(otevri, PRODLEVA_MS);
    // Odchod myší nahoru sleduje jen počítač; na dotyku to nedává smysl.
    if (window.matchMedia('(hover: hover)').matches) {
      document.addEventListener('mouseout', odchod);
    }
  }

  if (document.readyState === 'complete') naplanuj();
  else window.addEventListener('load', naplanuj, { once: true });
})();
